import type { ReactNode } from "react";

import { useAuth } from "./AuthProvider";

export function AuthGate({ children }: { children: ReactNode }) {
  const { isLoading, isAuthenticated, error } = useAuth();

  if (isLoading) {
    return (
      <div className="auth-gate">
        <p>Authenticating...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="auth-gate">
        <p>Authentication failed</p>
        <p className="auth-gate-error">{error}</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div className="auth-gate">
        <p>Not authenticated</p>
      </div>
    );
  }

  return <>{children}</>;
}
